<div class="playlist_class">

    <div class="navbar_playlist" style="display:flex">
        <div class="navitem_1" style="flex:50%;" (click)="active='add'">
            Add to Playlist
            <ng-container *ngIf="active=='add'">
                <div id="navhighlight1"></div>
            </ng-container>
        </div>
        <div class="navitem_2" style="flex:50%" (click)="active='create'">
            Create Playlist
            <ng-container *ngIf="active=='create'">
                <div id="navhighlight2"></div>
            </ng-container>
        </div>
    </div>
    <hr>

    <div>

        <ng-container *ngIf="active=='create';else addBlock">
            <form #createFormDirective="ngForm" [formGroup]="createPlaylistForm"
                (ngSubmit)="onCreatePlaylistFormSubmit(createFormDirective)">
                <div class="header">Playlist Title</div>
                <div class="playlist_name">
                    <input type="text" placeholder="Your playlist name" formControlName="name" required
                        [ngClass]="{'br-err':formSubmit && ( name.errors?.required || !name.errors?.required && name.errors?.validSongTitle)}">
                    <span class="err-face"
                        *ngIf="name.errors?.required || !name.errors?.required && name.errors?.validSongTitle"
                        [matTooltip]="name.errors?.required ? 'Please enter Playlist Name' : !name.errors?.required &&
                    name.errors?.validSongTitle ? 'Please enter a valid title' : null"
                        matTooltipClass="sd-title-tooltip">

                    </span>
                </div>
                <div class="playlist_type" formControlName="privacy">
                    <span style="margin-right:15px;">
                        <input type="radio" id="publicButton" formControlName="privacy" [value]="true">
                        <label for="publicButton">Public Playlist</label>
                    </span>
                    <span>
                        <input type="radio" id="privateButton" formControlName="privacy" [value]="false">
                        <label for="privateButton">Private Playlist</label>
                    </span>
                </div>
                <mat-error class="mb-2" *ngIf="createPlaylistError">{{createPlaylistErrorMsg}}</mat-error>
                <div class="save">
                    <button type="button" [disabled]="!createPlaylistForm.valid || processing"
                        type="submit">{{(processing)?'Saving':'Save'}}</button>
                </div>
                <div *ngFor="let track of data.tracks" class="playlist_track">
                    <img [lazyLoad]="track.image"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
                        alt="Album Art" style="vertical-align:middle; float:left;">
                    <span class="track_title">{{track.title}}</span>
                    <span class="track_artist">{{track.artist}}</span>
                </div>
            </form>
            <div class="p-20"></div>
        </ng-container>

        <ng-template #addBlock>
            <div *ngIf="addToPlaylistError">{{addToPlaylistErrorMsg}}</div>
            <div class="add_playlist" *ngFor="let playlist of playlists; let i=index">
                <div class="playlist_rows" style="display:flex;align-items:center">
                    <div class="row_img">
                        <img *ngIf="!(playlist.cover_pic==null || playlist.cover_pic=='')"
                            [lazyLoad]="playlist.cover_pic"
                            defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
                            alt="Album Art">
                        <img *ngIf="((playlist.cover_pic==null || playlist.cover_pic=='') && playlist.tracks.length!==0)"
                            [lazyLoad]="playlist.tracks[0].image"
                            defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
                            alt="Album Art">
                              <img *ngIf="((playlist.cover_pic==null || playlist.cover_pic=='') && playlist.tracks.length==0)"
                            src="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png"
                            alt="Album Art">
                            
                    </div>
                    <div class="row_song" style="display:flex;align-items:center">
                        <div class="track_details">
                            <div class="track_name" *ngIf="!global.isMobile()">{{(playlist.name.length >10)? (playlist.name |
                                slice:0:10)+'...':(playlist.name ) }} </div>
                                <div class="track_name" *ngIf="global.isMobile()">{{(playlist.name.length >10)? (playlist.name |
                                    slice:0:10)+'...':(playlist.name ) }} </div>
                            <div class="track_num">
                                <img src="../../../assets/images/music.svg"
                                    style="vertical-align:middle">
                                <span style="margin-right:5px">{{playlist.tracks.length}} {{(playlist.tracks.length==1)?'Track':'Tracks'}}</span>
                                <span  *ngIf="global.isMobile()"> 
                                    <img *ngIf="playlist.is_public" src="../../../assets/images/unlock.svg">
                                    <img *ngIf="!playlist.is_public" src="../../../assets/images/lock.svg">
                                </span>
                            </div>
                        </div>
                        <div class="lock" *ngIf="!global.isMobile()">
                            <img *ngIf="playlist.is_public" src="../../../assets/images/unlock.svg">
                            <img *ngIf="!playlist.is_public" src="../../../assets/images/lock.svg">
                        </div>
                    </div>

                
                        <a type="button"  (click)="addToPlaylist(songSlugs, playlist.slug)"><span class="addbutton">Add to Playlist</span></a>
                    
                </div>
                <div class="bottom_padding" style="height:22px"></div>
            </div>
            <div class="m-b-40 text-center" *ngIf="playlistsLoaded && playlists.length==0">
                You don't have any playlists yet
            </div>
        </ng-template>

    </div>
</div>
